import React from 'react'
import { useDispatch } from 'react-redux'
import { post } from '../Accounts/API'
import ReCAPTCHA from 'react-google-recaptcha'
import { setDialog } from '../../actions/navigation'
import Modal from './Modal'

export default () => {
    const dispatch = useDispatch()

    const [useAgain, setUseAgain] = React.useState('')
    const [improvement, setImprovement] = React.useState('')
    const [userEmail, setUserEmail] = React.useState('')
    const [userType, setUserType] = React.useState('')
    const [otherRole, setOtherRole] = React.useState('')
    const [recaptchaValue, setRecaptchaValue] = React.useState(null)
    const [isLoading, setLoading] = React.useState(false)
    const [result, setResult] = React.useState(null)

    const canSubmit = recaptchaValue && [useAgain, userType].some(item => !!item)

    return (
        <Modal>
            <div className="feedback">
                <header>
                    <h2 className="title">Feedback</h2>
                </header>
                <section>
                    {result !== null && (
                        <p>
                            {result === 'success'
                                ? 'Your feedback has been submitted.'
                                : 'There was an error submitting your feedback. Please try again later.'}
                        </p>
                    )}
                    {result === null && (
                        <>
                            <div className="field">
                                <label className="label">
                                    <strong>How would you describe your role?</strong>
                                </label>

                                <div className="control">
                                    <div>
                                        <label className="radio">
                                            <input
                                                type="radio"
                                                checked={userType === 'DEVELOPER'}
                                                onChange={() => setUserType('DEVELOPER')}
                                            />{' '}
                                            Developer
                                        </label>
                                    </div>
                                    <div>
                                        <label className="radio">
                                            <input
                                                type="radio"
                                                checked={userType === 'PLANNER'}
                                                onChange={() => setUserType('PLANNER')}
                                            />{' '}
                                            Public/Private Sector Planner
                                        </label>
                                    </div>
                                    <div>
                                        <label className="radio">
                                            <input
                                                type="radio"
                                                checked={userType === 'OFFICIAL'}
                                                onChange={() => setUserType('OFFICIAL')}
                                            />{' '}
                                            Elected Official Staff
                                        </label>
                                    </div>
                                    <div>
                                        <label className="radio">
                                            <input
                                                type="radio"
                                                checked={userType === 'RESIDENT'}
                                                onChange={() => setUserType('RESIDENT')}
                                            />{' '}
                                            Resident
                                        </label>
                                    </div>
                                    <div>
                                        <label className="radio">
                                            <input
                                                type="radio"
                                                checked={userType === 'OTHER'}
                                                onChange={() => setUserType('OTHER')}
                                            />{' '}
                                            Other
                                        </label>
                                    </div>
                                </div>
                            </div>

                            {userType === 'Other' ? (
                                <div className="field">
                                    <label className="label">
                                        <strong>Describe your role:</strong>
                                    </label>
                                    <input
                                        type="text"
                                        name="role-other"
                                        className="role-other"
                                        onChange={e => setOtherRole(e.target.value)}
                                    />
                                </div>
                            ) : (
                                ''
                            )}

                            <div className="field">
                                <label className="label">
                                    <strong>How likely are you to use this tool again?</strong>
                                </label>
                                <div className="scale">
                                    <span>Not likely</span>
                                    <div className="control stars">
                                        <input
                                            id="r1"
                                            type="radio"
                                            name=""
                                            checked={useAgain === '5'}
                                            onChange={() => setUseAgain('5')}
                                        />
                                        <label className="radio star" for="r1"></label>

                                        <input
                                            id="r2"
                                            type="radio"
                                            name=""
                                            checked={useAgain === '4'}
                                            onChange={() => setUseAgain('4')}
                                        />
                                        <label className="radio star" for="r2"></label>

                                        <input
                                            id="r3"
                                            type="radio"
                                            name=""
                                            checked={useAgain === '3'}
                                            onChange={() => setUseAgain('3')}
                                        />
                                        <label className="radio star" for="r3"></label>

                                        <input
                                            id="r4"
                                            type="radio"
                                            name=""
                                            checked={useAgain === '2'}
                                            onChange={() => setUseAgain('2')}
                                        />
                                        <label className="radio star" for="r4"></label>
                                        <input
                                            id="r5"
                                            type="radio"
                                            name=""
                                            checked={useAgain === '1'}
                                            onChange={() => setUseAgain('1')}
                                        />
                                        <label className="radio star" for="r5"></label>
                                    </div>
                                    <span>Very likely</span>
                                </div>
                            </div>

                            <div className="field">
                                <label className="label">
                                    <strong>Comments or suggestions?</strong>{' '}
                                    <span className="optional">(Optional)</span>
                                </label>
                                <div className="control">
                                    <textarea
                                        className="textarea"
                                        style={{ minHeight: '100px' }}
                                        onChange={e => setImprovement(e.target.value)}
                                        value={improvement}
                                    />
                                </div>
                            </div>

                            <div className="field">
                                <label className="label">
                                    <strong>Contact Email</strong> <span className="optional">(Optional)</span>
                                </label>
                                <div className="control">
                                    <input
                                        type="email"
                                        name="email"
                                        className="email"
                                        onChange={e => setUserEmail(e.target.value)}
                                        value={userEmail}
                                    />
                                </div>
                            </div>

                            <div className="field recaptcha" style={{ marginTop: '20px' }}>
                                <ReCAPTCHA
                                    sitekey={window.SETTINGS.recaptcha_key}
                                    onChange={value => setRecaptchaValue(value)}
                                />
                            </div>
                        </>
                    )}
                </section>
                <footer>
                    {result !== null && (
                        <button
                            className="button is-primary"
                            onClick={() => dispatch(setDialog(''))}
                            aria-label="Close modal"
                        >
                            Close
                        </button>
                    )}
                    {result === null && (
                        <button
                            disabled={isLoading || !canSubmit}
                            className={`button is-primary ${isLoading ? 'is-loading' : ''}`}
                            type="submit"
                            onClick={() => {
                                setLoading(true)
                                post('/feedback/', {
                                    user_type: userType,
                                    other_role: otherRole,
                                    use_again: useAgain,
                                    improvement,
                                    user_email: userEmail,
                                    recaptcha: recaptchaValue
                                })
                                    .then(() => {
                                        setLoading(false)
                                        setResult('success')
                                    })
                                    .catch(() => {
                                        setLoading(false)
                                        setResult('failure')
                                    })
                            }}
                            aria-label="Submit feedback"
                        >
                            SUBMIT
                        </button>
                    )}
                </footer>
            </div>
        </Modal>
    )
}
